import type { RouteRecordRaw } from 'vue-router';

export const rolesRoutes: RouteRecordRaw[] = [
  {
    path: '/roles',
    name: 'roles',
    component: () => import('./views/RolesView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default rolesRoutes;